import { render } from "./CompanyList.vue?vue&type=template&id=4f82ce30"
import script from "./CompanyList.vue?vue&type=script&lang=js"
export * from "./CompanyList.vue?vue&type=script&lang=js"

import "./CompanyList.vue?vue&type=style&index=0&id=4f82ce30&lang=css"

import exportComponent from "D:\\Projects\\fostcrm-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__